import { Button, Flex, Form, Grid, Input, Typography } from 'antd';
import { Title } from './title';
import { useState } from 'react';

export const TaskAppendComment = (props) => {
    const { onCommentSubmit } = props;
    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false);

    const onFinish = async (values) => {
        setLoading(true);
        const res = await onCommentSubmit(values);
        if (res) form.resetFields();
        setLoading(false);
    }
    const screens = Grid.useBreakpoint();

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            style={{ width: '100%' }}
            requiredMark={false}
        >
            <Flex vertical gap={8}> 
                <Title level={4}>Комментарий</Title>
                <Form.Item
                    name="comment"
                    style={{ margin: 0 }}
                    rules={[{ required: true, message: <Typography.Text type='danger' style={{ fontSize: 16 }}>Введите комментарий</Typography.Text>, }]}
                >
                    <Input.TextArea size="large" rows={4} placeholder="Напишите комментарий к задаче" />
                </Form.Item>
                <Typography.Text type='secondary'>Если вы хотите дополнить заявку, напишите комментарий</Typography.Text>
                <Form.Item shouldUpdate style={{ margin: 0, textAlign: screens.xs ? 'center' : 'right', }} nost>
                    {() => (
                        <Button
                            size="large"
                            type="primary"
                            htmlType="submit"
                            style={{ minWidth: 160 }}
                            disabled={!form.getFieldValue('comment') || form.getFieldValue('comment').trim() === ''}
                            loading={loading}
                        >
                            Отправить сообщение
                        </Button>
                    )}
                </Form.Item>
            </Flex>
        </Form>
    )
}